/**
 * 路由配置入口文件
 * 统一管理所有路由配置
 */

import { createRouter, createWebHistory } from 'vue-router';
import { setupRouterGuards } from './auth.guard';
import { appRoutes } from './app.routes';
import { userRoutes } from './user.routes';

// 合并所有路由
const routes = [
  ...appRoutes,
  ...userRoutes
];

// 创建路由实例
const router = createRouter({
  history: createWebHistory(),
  routes,
  // 路由滚动行为
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

// 设置路由守卫
setupRouterGuards(router);

export default router;
